module.exports = __webpack_public_path__ + "static/media/no_image.6732bd42.png";